import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
    ${({ theme }) => css`
        color: ${theme.v2.colors.neutral.lowDark};
        font-family: ${theme.v2.font.family.primary};
        display: flex;
        margin: 0;
        position: relative;
        z-index: 1;

        @media (max-width: ${theme.v2.breakpoints.sm}) {
            flex-direction: column;
        }
    `};
`;

export const Image = styled.img`
    ${({ theme }) => css`
        width: 100%;
        height: max-content;

        @media (min-width: ${theme.v2.breakpoints.sm}) {
            width: 305px;
            height: auto;
            object-fit: fill;
            margin: 0;
            border-radius: 16px 0 0 16px;
        }
    `};
`;

export const Content = styled.div`
    ${({ theme }) => css`
        background-color: ${theme.v2.colors.white.primary};
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 6px;
        padding: 22px 24px;
        flex: 1;

        @media (min-width: ${theme.v2.breakpoints.sm}) {
            border-radius: 0 16px 16px 0;
        }
    `};
`;

export const Title = styled.div`
    ${({ theme }) => css`
        color: ${theme.v2.colors.brand.primaryExtradark};
        font-family: ${theme.v2.font.family.primary};
        font-size: ${theme.v2.font.sizes.sm2};
        font-weight: ${theme.v2.font.weights.medium};
        line-height: ${theme.v2.font.lineHeight.text};
    `};
`;

export const Description = styled.div`
    ${({ theme }) => css`
        color:${theme.v2.colors.neutral.lowDark};
        font-family: ${theme.v2.font.family.primary};
        font-size: ${theme.v2.font.sizes.xxs};
        font-weight: ${theme.v2.font.weights.regular};
        line-height: ${theme.v2.font.lineHeight.text};
    `};
`;

export const ButtonWrapper = styled.div`
    margin: 10px 0 0 0;
`;

export const SkeletonList = styled.div`
    gap: 24px;
    display: grid;
    grid-template-columns: 305px 1fr;
    border-radius: 16px;
`;
